import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { sections } from '../../../common/config';
import Somersby from './Somersby';
import Joy from './Joy';
import WebGL from './WebGL';
import useAnimation from './useAnimation';

const Wrapper = styled.section`
  --background: #eee;

  position: relative;
  height: ${sections.height.landing}vh;
  width: 100%;

  background: var(--background);
  overflow: hidden;
`;

const Landing = () => {
  const ref = useRef<HTMLDivElement>(null);

  useAnimation(ref);

  return (
    <Wrapper>
      <WebGL />

      <div ref={ref}>
        <Somersby />
        <Joy />
      </div>
    </Wrapper>
  );
}

export default Landing;